import type { ComponentProps } from 'react';

const SadPumpkin = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="76"
      height="66"
      viewBox="0 0 76 66"
      fill="none"
      {...props}
    >
      <path
        d="M40.612 14.4312C41.0355 14.1412 41.5649 14.0094 42.0944 14.0622C45.5092 14.3784 53.5037 16.5925 53.1067 26.7401C53.1067 26.7401 39.9502 27.1618 40.2149 14.8792C40.2149 14.6157 40.5855 14.6684 40.612 14.4312Z"
        fill="#85CFC9"
      />
      <path
        d="M47.0454 21.8631C44.107 18.3312 39.7921 15.0893 39.7656 15.0629L40.8774 13.5869C41.0627 13.7187 45.4041 16.9607 48.4749 20.6771L47.0454 21.8631Z"
        fill="#355D60"
      />
      <path
        d="M34.2797 23.7338L32.4531 23.3648C33.8032 16.8546 42.433 12.0048 42.8036 11.7939L43.7037 13.4017C43.6242 13.4545 35.4709 18.067 34.2797 23.7338Z"
        fill="#355D60"
      />
      <path
        d="M51.6745 38.943C51.6215 41.2888 51.0656 43.6082 50.0597 45.7432C49.8479 46.1649 49.6361 46.5866 49.3979 47.0083C47.9419 49.565 45.9036 51.6999 43.5741 53.3077C40.1857 55.6799 36.2414 56.9451 32.6677 56.7869C28.8293 56.6288 24.832 55.39 21.4966 53.1232C19.167 51.5418 17.1287 49.4332 15.7257 46.8502C15.5139 46.4812 15.3286 46.1122 15.1433 45.7168C14.1903 43.5819 13.6609 41.3151 13.555 38.9693C13.5285 38.3631 13.5285 37.7305 13.555 37.0716C14.1903 21.2835 29.7028 19.8866 33.1442 22.2851C33.1442 22.2851 46.3536 17.3826 50.9332 33.2761C51.4627 35.1211 51.7274 37.0189 51.6745 38.943Z"
        fill="#F58D7A"
      />
      <path
        d="M49.3958 46.9823C47.9399 49.539 45.9015 51.6739 43.572 53.2817C41.6925 52.6755 40.4219 51.5158 40.4219 50.1715C40.4219 48.1947 43.2279 46.6133 46.6957 46.6133C47.6222 46.6396 48.5487 46.7714 49.3958 46.9823Z"
        fill="#E06257"
      />
      <path
        d="M24.1437 50.1979C24.1437 51.4103 23.0849 52.491 21.4701 53.1236C19.1406 51.5421 17.1022 49.4335 15.6992 46.8505C16.3875 46.7187 17.1022 46.6396 17.8964 46.6396C21.3377 46.6396 24.1437 48.2474 24.1437 50.1979Z"
        fill="#E06257"
      />
      <path
        d="M38.2813 29.5851C37.7518 26.2114 32.4045 23.8656 32.3516 23.8392L33.0663 22.126C33.331 22.2314 39.3931 24.8935 40.1078 29.2952L38.2813 29.5851Z"
        fill="#E06257"
      />
      <path
        d="M24.9134 43.7403C21.8691 43.7403 20.4661 40.6565 20.1484 38.996L21.975 38.6533C22.0015 38.7851 22.6368 41.9216 24.9663 41.8689C27.4017 41.8162 27.7459 38.7587 27.7723 38.6533L29.6254 38.8378C29.4665 40.4983 28.3018 43.6612 25.0193 43.7403H24.9134Z"
        fill="#B43432"
      />
      <path
        d="M40.5032 43.7403C37.459 43.7403 36.0559 40.6565 35.7383 38.996L37.5648 38.6533C37.5913 38.7851 38.2266 41.9216 40.5562 41.8689C42.9916 41.8162 43.3357 38.7587 43.3622 38.6533L45.2152 38.8378C45.0564 40.4983 43.8916 43.6612 40.6091 43.7403H40.5032Z"
        fill="#B43432"
      />
      <path
        d="M31.0805 49.0902L29.2539 48.7212C29.7833 46.0327 31.6628 45.2156 33.2247 45.3474C34.9718 45.5056 36.8778 46.9552 36.9043 48.8793L35.0512 48.9057C35.0248 48.1149 34.0718 47.2715 33.0394 47.1924C32.007 47.1134 31.3452 47.7459 31.0805 49.0902Z"
        fill="#B43432"
      />
      <path
        d="M33.3818 65.1411C38.9666 65.1411 43.494 64.2797 43.494 63.2171C43.494 62.1544 38.9666 61.293 33.3818 61.293C27.7969 61.293 23.2695 62.1544 23.2695 63.2171C23.2695 64.2797 27.7969 65.1411 33.3818 65.1411Z"
        fill="#FEE0CC"
      />
      <path
        d="M8.67993 50.5674C9.39631 50.5674 9.97705 49.9892 9.97705 49.2759C9.97705 48.5626 9.39631 47.9844 8.67993 47.9844C7.96355 47.9844 7.38281 48.5626 7.38281 49.2759C7.38281 49.9892 7.96355 50.5674 8.67993 50.5674Z"
        fill="#FEE0CC"
      />
      <path
        d="M26.4972 10.5031C27.0674 10.5031 27.5296 10.0429 27.5296 9.4752C27.5296 8.90749 27.0674 8.44727 26.4972 8.44727C25.9271 8.44727 25.4648 8.90749 25.4648 9.4752C25.4648 10.0429 25.9271 10.5031 26.4972 10.5031Z"
        fill="#FEE0CC"
      />
      <path
        d="M58.0038 34.7522C58.5301 34.7522 58.9568 34.3274 58.9568 33.8034C58.9568 33.2793 58.5301 32.8545 58.0038 32.8545C57.4774 32.8545 57.0508 33.2793 57.0508 33.8034C57.0508 34.3274 57.4774 34.7522 58.0038 34.7522Z"
        fill="#FEE0CC"
      />
      <path
        d="M57.3066 45.6424L56.832 47.4258L62.2566 48.8568L62.7312 47.0734L57.3066 45.6424Z"
        fill="#FFC700"
      />
      <path
        d="M55.3123 50.6552L54.2461 52.1641L58.8356 55.3793L59.9018 53.8704L55.3123 50.6552Z"
        fill="#FFC700"
      />
      <path
        d="M2.06585 29.5528L1.43359 31.2871L6.7089 33.1937L7.34116 31.4593L2.06585 29.5528Z"
        fill="#FFC700"
      />
      <path
        d="M6.1385 36.7134L0.5 36.7471L0.510894 38.5921L6.14939 38.5585L6.1385 36.7134Z"
        fill="#FFC700"
      />
      <path
        d="M68.1686 33.5122C72.2184 33.5122 75.5013 30.2434 75.5013 26.2112C75.5013 22.1789 72.2184 18.9102 68.1686 18.9102C64.1189 18.9102 60.8359 22.1789 60.8359 26.2112C60.8359 30.2434 64.1189 33.5122 68.1686 33.5122Z"
        fill="#FEE0CC"
      />
      <path
        d="M67.0039 27.2665L68.3275 21.5996L70.8953 22.5221L68.3275 27.7409L67.0039 27.2665Z"
        fill="#E9817B"
      />
      <path
        d="M66.8991 30.3243C67.5424 30.3243 68.0639 29.8051 68.0639 29.1646C68.0639 28.5241 67.5424 28.0049 66.8991 28.0049C66.2559 28.0049 65.7344 28.5241 65.7344 29.1646C65.7344 29.8051 66.2559 30.3243 66.8991 30.3243Z"
        fill="#E9817B"
      />
      <path
        d="M61.2055 25.5527L56.6523 28.6102L62.2644 28.8474"
        fill="#FEE0CC"
      />
      <path
        d="M55.6197 8.02566C57.608 8.02566 59.2199 6.42077 59.2199 4.44105C59.2199 2.46133 57.608 0.856445 55.6197 0.856445C53.6314 0.856445 52.0195 2.46133 52.0195 4.44105C52.0195 6.42077 53.6314 8.02566 55.6197 8.02566Z"
        fill="#FEE0CC"
      />
      <path
        d="M55.0352 4.94233L55.697 2.1748L56.9411 2.62288L55.697 5.17955L55.0352 4.94233Z"
        fill="#E9817B"
      />
      <path
        d="M54.9808 6.44391C55.3025 6.44391 55.5632 6.18429 55.5632 5.86404C55.5632 5.54379 55.3025 5.28418 54.9808 5.28418C54.6592 5.28418 54.3984 5.54379 54.3984 5.86404C54.3984 6.18429 54.6592 6.44391 54.9808 6.44391Z"
        fill="#E9817B"
      />
      <path
        d="M52.4169 4.8623L50.7227 7.12904L53.5287 6.44375"
        fill="#FEE0CC"
      />
      <path
        d="M8.68377 19.2279C11.3008 19.2279 13.4222 17.1156 13.4222 14.51C13.4222 11.9043 11.3008 9.79199 8.68377 9.79199C6.06679 9.79199 3.94531 11.9043 3.94531 14.51C3.94531 17.1156 6.06679 19.2279 8.68377 19.2279Z"
        fill="#FEE0CC"
      />
      <path
        d="M9.1076 15.406L5.85156 13.4819L6.91044 12.1113L9.66351 14.6944L9.1076 15.406Z"
        fill="#E9817B"
      />
      <path
        d="M10.2442 16.6186C10.6682 16.6186 11.0119 16.2764 11.0119 15.8542C11.0119 15.4321 10.6682 15.0898 10.2442 15.0898C9.82027 15.0898 9.47656 15.4321 9.47656 15.8542C9.47656 16.2764 9.82027 16.6186 10.2442 16.6186Z"
        fill="#E9817B"
      />
      <path
        d="M11.1755 17.1982L12.102 21.3891L9.03125 18.4898"
        fill="#FEE0CC"
      />
    </svg>
  );
};

export default SadPumpkin;
